import React, {Component} from 'react'

import TableHeadCellContainer from '../tableheadcell/TableHeadCell.container'

class TableHeadRow extends Component {
  renderHeaders() {
    let freezeColOffset = -1

    if (this.props.freezeCol) {
      freezeColOffset = 0
    }

    const sort = this.props.api.getSort()
    let count = 0

    const headers = this.props.headers.map((header, i) => {
      count = i

      const value = (i > freezeColOffset) ? (0 - this.props.scrollOffset) : 0

      // left: (i > freezeColOffset) ? (0 - this.props.scrollOffset) : 0,

      const style = {
        transform: 'translate(' + value + 'px)',
        width: header.width || 200
      }

      const sortStatus = (sort && sort._sort === header.datafield) ? sort : null

      return (
        <TableHeadCellContainer
          data-testid='table-headercell'
          className={(this.props.freezeCol) ? 'frozen-cell' : ''}
          key={'header_' + i} style={style}
          header={header}
          sortStatus={sortStatus}
          handleSort={this.props.handleSort}
          multiselect={this.props.multiselect}
          count={i}
          handleSelectAll={this.props.handleSelectAll}
          headerChecked={this.props.headerChecked}
          analytics={this.props.analytics}
        />
      )
    })

    const valueFlex = (freezeColOffset > -1) ? (0 - this.props.scrollOffset) : 0

    let style = {
      transform: 'translate(' + valueFlex + 'px)'
    }

    if (this.props.rowActions) {
      headers.push(
        <TableHeadCellContainer
          data-testid='table-headercell'
          className={(this.props.freezeCol) ? 'frozen-cell' : ''}
          key={'header_actions'} style={style}
          header={{
            title: '',  
            width: this.props.rowActions.width
          }}
          actionCellHeader={true}
          sortStatus={null}
          handleSort={this.props.handleSort}
          multiselect={this.props.multiselect}
          count={count + 1}
          handleSelectAll={this.props.handleSelectAll}
          headerChecked={this.props.headerChecked}
          analytics={this.props.analytics}
        />)
    }

    if (this.props.multiLineRow && this.props.multiLineRow.enabled) {
      style = {
        transform: 'translate(' + valueFlex + 'px)',
        width: this.props.multiLineRow.width || 200
      }
      headers.splice(this.props.multiLineRow.columnPosition, 0,
        <TableHeadCellContainer
          data-testid='table-headercell'
          className={(this.props.freezeCol) ? 'frozen-cell' : ''}
          key={'header_multilinecolumn'} style={style}
          header={{
            title: '',
            width: this.props.multiLineRow.width
          }}
          sortStatus={null}
          handleSort={this.props.handleSort}
          multiselect={this.props.multiselect}
          count={count + 2}
          handleSelectAll={this.props.handleSelectAll}
          headerChecked={this.props.headerChecked}
          analytics={this.props.analytics}
        />
      )
    }

    return headers
  }

  render() {
    return (
      <tr>
        {this.renderHeaders()}
      </tr>
    )
  }
}

export default TableHeadRow
